import { useState } from 'react';

import { Icon } from '@components';
import CalendarV2 from '@components/calendar/CalendarV2';
import { MIN_SELECTABLE_DATE } from '@features/lead-management/constants/leadSettings';
import ModalV2 from '@layouts/modal/Modal.v2';

import theme from '../../../../../themes/colors';

interface SaveMetaIntegrationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (date: Date) => void;
}

const SaveMetaIntegrationModal = ({
  isOpen,
  onClose,
  onConfirm
}: SaveMetaIntegrationModalProps) => {
  const [syncDate, setSyncDate] = useState<Date | null>(new Date());

  const handleApply = () => {
    if (syncDate) {
      onConfirm(syncDate);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <ModalV2
      title="Sync leads from"
      description="Only leads captured on or after the selected date will be synced from Meta."
      onClose={onClose}
      showCloseButton
      primaryButtonLabel="Sync"
      secondaryButtonLabel="Cancel"
      primaryButtonClick={handleApply}
      secondaryButtonClick={onClose}
      primaryButtonDisabled={!syncDate}
      isClickOutsideRequired
      className="w-[462px] !rounded-2xl"
      headerClassName="!border-b-0 !pb-0"
      primaryButtonStyle="!w-[100px] !h-[50px]"
      secondaryButtonStyle="!w-[100px] !h-[50px]"
    >
      <div className="flex flex-col">
        <CalendarV2
          date={syncDate}
          onChange={(date) => setSyncDate(date)}
          minDate={MIN_SELECTABLE_DATE}
          maxDate={new Date()}
        />
        <div className="mt-3 flex items-center gap-2 rounded-[4px] border border-cofeeGreyBlue4 bg-cofeeBlue1 p-3">
          <Icon
            name="alert-circle"
            size="24"
            stroke={theme.cofeeBlue9}
            strokeWidth={1.5}
          />
          <p className="text-sm font-medium text-cofeeGreyBlue8">
            Previously synced leads will not be updated.
          </p>
        </div>
      </div>
    </ModalV2>
  );
};

export default SaveMetaIntegrationModal;
